import { render, staticRenderFns } from "./RequestsWithTag.vue?vue&type=template&id=07664472&"
import script from "./RequestsWithTag.vue?vue&type=script&lang=js&"
export * from "./RequestsWithTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports